import { createContext } from "@smartsheet/lodestar-utils";
import { useContext } from "react";
const defaultContext = {
  type: "info"
};
const ToastContext = createContext(defaultContext, "ToastContext");
export const ToastContextProvider = ToastContext.Provider;
export const useToastContext = () => useContext(ToastContext);
//# sourceMappingURL=ToastContext.js.map